import React, { useState, useEffect } from "react";
import ScrollMessageGrid from "./ScrollMessageGrid";
import ScrollMessageForm from "./ScrollMessageForm";
import ConfirmDialog from "../../../utils/ConfirmDialog";

const API_URL = "https://kvrstarlightmedicalacademy.com/api/scrollmessage.php";

const EditScrollMessage = () => {
  const [messages, setMessages] = useState([]);
  const [view, setView] = useState("grid");
  const [editItem, setEditItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((data) => setMessages(data))
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  const handleCreate = () => {
    setEditItem(null);
    setView("create");
  };

  const handleEdit = (item) => {
    setEditItem(item);
    setView("edit");
  };

  const askDelete = (item) => {
    setDeleteItem(item);
    setShowConfirm(true);
  };

  const confirmDelete = async () => {
    if (!deleteItem) return;
    try {
      await fetch(`${API_URL}?id=${deleteItem.id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      setMessages(messages.filter((m) => m.id !== deleteItem.id));
    } catch (err) {
      console.error("Delete error:", err);
    } finally {
      setShowConfirm(false);
      setDeleteItem(null);
    }
  };

  const handleSubmit = async (messageText) => {
    try {
      if (editItem) {
        await fetch(`${API_URL}?id=${editItem.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ message: messageText }),
        });
        setMessages(
          messages.map((m) =>
            m.id === editItem.id ? { ...m, message: messageText } : m
          )
        );
      } else {
        const res = await fetch(API_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ message: messageText }),
        });
        const data = await res.json();
        setMessages([...messages, { id: data.id, message: messageText }]);
      }
    } catch (err) {
      console.error("Submit error:", err);
    }
    setView("grid");
  };

  const handleCancel = () => {
    setView("grid");
  };

  return (
    <div className="container mt-4">
      {view === "grid" && (
        <ScrollMessageGrid
          data={messages}
          onEdit={(index) => handleEdit(messages[index])}
          onDelete={(index) => askDelete(messages[index])}
          onCreate={handleCreate}
        />
      )}
      {(view === "create" || view === "edit") && (
        <ScrollMessageForm
          initialValue={editItem ? editItem.message : ""}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}

      {showConfirm && (
        <ConfirmDialog
          message={`Are you sure you want to delete "${
            deleteItem?.message || "this message"
          }"?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowConfirm(false)}
        />
      )}
    </div>
  );
};

export default EditScrollMessage;
